import React from "react";
//#region types
import { MultiProfilesProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { Avatar, Grid, Tooltip } from "@mui/material";
import ProfileImage from "./profileImage";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MultiProfiles: React.FC<MultiProfilesProps> = ({ maxProfiles, profiles, showWint }) => {
  const maxProfileCountToShow = maxProfiles ? maxProfiles + (showWint ? -1 : 0) : undefined;
  const profilesToShow = maxProfileCountToShow ? profiles.slice(0, maxProfileCountToShow) : profiles;
  const hiddenProfiles = maxProfileCountToShow ? profiles.slice(maxProfileCountToShow) : [];
  const hiddenProfileNames = hiddenProfiles.map((p) => p.name).join(", ");

  return (
    <Grid container direction="row" flexWrap="nowrap" className={cssExports.multiProfiles}>
      {showWint ? (
        <Grid item className={cssExports.profileItem}>
          <ProfileImage />
        </Grid>
      ) : (
        <></>
      )}
      {profilesToShow.map((p) => (
        <Grid item className={cssExports.profileItem}>
          <Tooltip
            disableInteractive
            placement="top"
            title={p.name}
            arrow
            classes={{
              tooltip: cssExports.tooltip,
              popper: cssExports.tooltipPopper,
              arrow: cssExports.tooltipArrow,
            }}
          >
            <span>
              <ProfileImage id={p.id} name={p.name} />
            </span>
          </Tooltip>
        </Grid>
      ))}
      {hiddenProfiles.length > 0 ? (
        <Grid item className={cssExports.profileItem}>
          <Tooltip
            disableInteractive
            placement="top"
            title={hiddenProfileNames}
            arrow
            classes={{
              tooltip: cssExports.tooltip,
              popper: cssExports.tooltipPopper,
              arrow: cssExports.tooltipArrow,
            }}
          >
            <span>
              <Avatar
                className={cssExports.profileAvatar}
                alt={hiddenProfileNames}
              >{`+${hiddenProfiles.length}`}</Avatar>
            </span>
          </Tooltip>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default MultiProfiles;
